import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

// Get the base URL for the current environment
function getAppUrl(): string {
  // Use appUrl from environment configuration if available
  if (environment.appUrl) {
    return environment.appUrl;
  }

  // Fallback to window.location.origin
  return window.location.origin;
}

// Get the logout redirect URL (home page)
function getLogoutRedirectUrl(): string {
  return `${getAppUrl()}/`;
}

// Get Cognito configuration from environment (no hardcoded values)
const region = environment.authConfig.region;
const userPoolId = environment.authConfig.userPoolId;
const clientId = environment.authConfig.userPoolWebClientId;

// Use the proper Cognito authority URL format per AWS documentation
const authority = `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`;

// Export the config in the format expected by angular-auth-oidc-client
export const authConfig: PassedInitialConfig = {
  config: {
    // Standard OIDC properties
    authority: authority,
    clientId: clientId,
    redirectUrl: getAppUrl(),
    responseType: 'code',
    scope: 'openid email phone',
    silentRenew: true,
    useRefreshToken: true,
    postLogoutRedirectUri: getLogoutRedirectUrl(),

    // Configure custom parameters for various requests
    customParamsAuthRequest: {
      // Add any custom parameters for auth
    },
    customParamsRefreshTokenRequest: {
      // Add any custom parameters for refresh
    },
    customParamsEndSessionRequest: {
      // For Cognito, we need to provide these parameters for logout
      client_id: clientId,
      redirect_uri: getAppUrl(),
      // Point logout redirect to home page
      post_logout_redirect_uri: getLogoutRedirectUrl()
    },

    // Standard OIDC configuration properties
    triggerAuthorizationResultEvent: false,
    maxIdTokenIatOffsetAllowedInSeconds: 600,
    issValidationOff: true,
    autoUserInfo: true,
  }
};
